import { Chip, Tooltip } from "@mui/material";

// Shows which accounting backend a record came from.
//
// The row's `source` is the only thing that decides it — provider ids carry no
// namespace any more. A row that has an id but no source predates the field and
// came from BILL; a row with neither says nothing rather than guessing.
export default function ProviderBadge({ source, providerId }: { source?: string; providerId?: string }) {
  const resolved = source || (providerId ? "bill" : "");
  if (!resolved) {
    return null;
  }
  const isIES = resolved === "ies";
  return (
    <Tooltip
      title={`Source: ${isIES ? "Intuit Enterprise Suite" : "Bill.com"}`}
      arrow
    >
      <Chip
        label={isIES ? "IES" : "BILL"}
        size="small"
        color={isIES ? "info" : "default"}
        variant={isIES ? "filled" : "outlined"}
        sx={{ height: 20, fontSize: 11, borderRadius: 0, fontWeight: 600 }}
      />
    </Tooltip>
  );
}
